<section id="main-section">
  <section id="content-section" [ngStyle]="{padding: modal ? '3rem' : '0'}">
    <div class="first-row">
      <div id="buttons-container" class="cursor-pointer">
        <div (click)="returnTrip(false)" [ngClass]="{ checked: !oneWay }">
          {{ "flights.form.roundtrip" | translate }}
        </div>
        <div (click)="returnTrip(true)" [ngClass]="{ checked: oneWay }">
          {{ "flights.form.noRoundtrip" | translate }}
        </div>
      </div>
      <div class="resident-discount" (click)="checkIfResident()">
        {{ "flight.form-flight.apply-resident" | translate }}
      </div>
    </div>

    <div id="form-container" style="padding: 2rem;">
      <form [formGroup]="formSearchFlight" *ngIf="formSearchFlight" style="width: 100%;">
        <div class="row origin-destination-container" id="places-row">
          <div class="col-5 input-containers">
            <mat-form-field appearance="none">
              <label for="origin">{{ "train.form-train.origin" | translate }}*</label>
              <div class="input-group" style="overflow: auto;">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button">
                    <img src="/assets/img/svg/flight-takeoff.svg" />
                  </button>
                </div>
                <input id="origin" placeholder="{{
                    'flight.form-flight.insert-ubication-airport' | translate
                  }}" class="form-control form-control--no-border border-radius-20" matInput
                  (input)="getAirports($event.target.value)" [formControl]="formSearchFlight.controls['origin']"
                  [matAutocomplete]="origin" />
              </div>
              <mat-autocomplete #origin="matAutocomplete"
                (optionSelected)="optionSelected('origin', $event.option.value)">
                <mat-option *ngFor="let option of airportList" [value]="option.title">
                  {{ option.title }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <button class="col-1 button-secondary swipe-button" (click)="swipeDestination()">
            <img src="assets/img/svg/flight/swipe.svg" alt="swipe" />
          </button>
          <div class="col-5 input-containers">
            <mat-form-field appearance="none">
              <label for="destination">{{ "train.form-train.destination" | translate }}*</label>
              <div class="input-group" style="overflow: auto;">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button">
                    <img src="/assets/img/svg/flight-landing.svg" />
                  </button>
                </div>
                <input id="destination" placeholder="{{
                    'flight.form-flight.insert-ubication-airport' | translate
                  }}" class="form-control form-control--no-border border-radius-20" matInput
                  [matAutocomplete]="destination" (input)="getAirports($event.target.value)"
                  [formControl]="formSearchFlight.controls['destination']" />
              </div>
              <mat-autocomplete #destination="matAutocomplete" (optionSelected)="
                  optionSelected('destination', $event.option.value)
                ">
                <mat-option *ngFor="let des of airportList" [value]="des.title">
                  {{ des.title }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="row" id="options-row">
          <div class="date">
            <div>
              <mat-form-field appearance="none">
                <label for="destination">{{ "flights.form.dateIn" | translate }}*</label>
                <div class="input-group">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" type="button">
                      <img src="/assets/img/svg/calendar-orange.svg" />
                    </button>
                  </div>
                  <input type="text" matInput style="display: none" />
                  <input id="dateIn" name="dateInput" ngbDatepicker #dateInput="ngbDatepicker"
                    class="form-control form-control--no-border" [minDate]="getInMinDate()" (click)="dateInput.toggle()"
                    (ngModelChange)="onDateChange()" formControlName="dateIn" placeholder="dd/mm/yyyy" />
                </div>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="!oneWay" class="date">
            <div>
              <mat-form-field appearance="none">
                <label for="dateOutput">{{ "flights.form.dateOut" | translate }}*</label>
                <div class="input-group">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" type="button">
                      <img src="/assets/img/svg/calendar-orange.svg" />
                    </button>
                  </div>
                  <input type="text" matInput style="display: none" />
                  <input id="dateOut" name="dateOutput" ngbDatepicker #dateOutput="ngbDatepicker"
                    (click)="dateOutput.toggle()" class="form-control form-control--no-border" formControlName="dateOut"
                    (ngModelChange)="onDateChange()" [minDate]="getOutMinDate()" placeholder="dd/mm/yyyy" />
                </div>
              </mat-form-field>
            </div>
          </div>
          <div class="options">
            <!-- <mat-select [formControl]="formSearchFlight.controls['type']">
                                <mat-option *ngFor="let seat of seats" [value]="seat.value">
                                    {{ seat.viewValue }}
                                </mat-option>
                            </mat-select> -->
            <!-- <select [formControl]="formSearchFlight.controls['type']">
                                <option *ngFor="let seat of seats" [value]="seat.value"> {{seat.viewValue}} </option>
                            </select> -->
            <div>
              <mat-form-field appearance="none">
                <label>
                  {{ "train.class-type" | translate }}
                </label>
                <input style="display: none" type="text" matInput />
                <div ngbDropdown>
                  <div ngbDropdownToggle class="dropdown-toggle cursor-pointer icon-arrow-rtl form-control--no-border">
                    {{
                    formSearchFlight.controls["type"].value != null
                    ? getSeatSelected()
                    : seats[seats.length - 1].viewValue
                    }}
                  </div>
                  <div ngbDropdownMenu class="dropdown-menu border-radius-20" aria-labelledby="dropdownBasic1">
                    <p ngbDropdownItem *ngFor="let seat of seats; let i = index" (click)="selectSeat(seat)" [ngClass]="{
                        selected:
                          seat.value ===
                          formSearchFlight.controls['type'].value.value,
                        last: seats.length - 1 === i
                      }">
                      {{ seat.viewValue }}
                    </p>
                  </div>
                </div>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row last-row" style="gap: 2rem;">
          <div class="passengers-container">
            <label class="project-label">{{'project.my-projects.travelers' | translate}}</label>
            <div class="passenger-summary" (click)="togglePassengersModal()">
              <img class="passenger-summary-icon-left" src="assets/img/svg/orange-person.svg" alt="Person" />
              <span class="passenger-summary-text">{{ travelers.length }} {{ 'train.form-train.travelers' | translate |
                lowercase }}</span>
            </div>
            <div class="passenger-modal-overlay" *ngIf="passengersModalOpen" (click)="closePassengersModal()"></div>
            <div class="passenger-modal-container" [ngClass]="{ 'modal-open-custom': passengersModalOpen }"
              *ngIf="passengersModalOpen">
              <div class="passengers-modal" (click)="$event.stopPropagation()">
                <div class="modal-content">
                  <div class="travellers-container">
                    <div *ngFor="let traveler of travelers; let i = index; trackBy: trackByIndex"
                      class="traveller-dropdown" style="font-size: 10px">
                      <mat-form-field appearance="fill" class="travellers traveler-selector">
                        <mat-select
                          [(value)]="travelers[i]"
                          (selectionChange)="onTravelersChanged()"
                          (closed)="onPanelClose()"
                          [disabled]="i === 0"
                          (openedChange)="onOpenedChange($event, input)"
                          [compareWith]="compareUsers"
                        >
                          <mat-select-trigger *ngIf="travelers[i] as t">
                            {{ t?.name }} {{ t?.lastname }}
                          </mat-select-trigger>

                          <mat-option>
                            <input
                              class="custom-mat-input"
                              #input
                              matInput
                              (input)="applyFilter($event.target.value)"
                              (click)="$event.stopPropagation()"
                              placeholder="{{ 'common.search-user' | translate }}"
                            />
                          </mat-option>
                          <mat-option *ngFor="let user of filteredUsers" [value]="user">
                            {{ user.name }} {{ user.lastname }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="add-passengers-container">
                    <button class="remove-btn add-passengers-btn" (click)="changeTravellers('remove')"
                      [disabled]="travelers.length <= 1">{{
                      "common.remove-passenger" | translate }}</button>
                    <button class="add-passengers-btn" (click)="changeTravellers('add')">{{ "common.add-passenger" |
                      translate }}</button>
                    <button class="add-passengers-btn" (click)="passengersModalOpen = false">{{ "common.confirm" |
                      translate }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="options">
            <label class="project-label">
              {{ 'group.group-form.single-travel-policies' | translate }}
            </label>
            <div class="d-flex align-items-center">
              <div class="input-group"
                [ngClass]="{ 'disabled-input': loadingPolicies || !policies?.length }"
              >
                <select
                  class="form-control form-control--squared select-input custom-select"
                  [(ngModel)]="selectedPolicy"
                  (ngModelChange)="onPolicyChange($event)"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="loadingPolicies || !policies?.length"
                >
                  <option [ngValue]="null" disabled *ngIf="!policies?.length">
                    {{ 'my-bookeds.flight.noAvailable' | translate }}
                  </option>
                  <option *ngFor="let policy of policies" [ngValue]="policy">
                    {{ policy.name }}
                  </option>
                </select>
              </div>
              <i
                style="margin-left: 0.5rem; font-size: 1.5rem;"
                class="ft-loader"
                *ngIf="loadingPolicies"
              ></i>
            </div>
          </div>
          <div class="options">
            <label class="project-label">{{'project.project-assign' | translate}}</label>
            <div class="project-container">
              <div style="border: none;" [ngClass]="{ 'disabled-input': loadingProjects || !formSearchFlight.controls['dateIn'].value 
                || (!formSearchFlight.controls['dateOut'].value && !oneWay) }">
                <select name="" id="" class="form-control form-control--squared select-input custom-select"
                  [(ngModel)]="selectedProject" [ngModelOptions]="{ standalone: true }" [disabled]="loadingProjects || !formSearchFlight.controls['dateIn'].value 
                  || (!formSearchFlight.controls['dateOut'].value && !oneWay)">
                  <option [ngValue]="null" disabled selected>{{'project.project-select' | translate}}</option>
                  <option *ngFor="let project of projects" [ngValue]="project">
                    {{ project.title }}
                  </option>
                </select>
              </div>

              <button *ngIf="!loadingProjects" class="btn no-focus-border" (click)="openTravelDialog()" [disabled]="loadingProjects || !formSearchFlight.controls['dateIn'].value 
                || (!formSearchFlight.controls['dateOut'].value && !oneWay)">
                <img src="assets/img/svg/add-booking-circle.svg" alt="Add booking" />
              </button>
              <i style="margin-left: 0.5rem; font-size: 1.5rem;" class="ft-loader" *ngIf="loadingProjects"></i>
            </div>
          </div>
        </div>
      </form>
      <div id="price-col">
        <mat-accordion *ngIf="accomInfo" style="margin-top: 1rem;">
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ "hotel.accom-info" | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <div *ngIf="accomInfo.needsAuth" style="display: flex; justify-content: center;">
                <span class="admin-permission-msg">{{ "authorization.permissions-required" | translate }}</span>
              </div>
              <div class="room" *ngFor="let room of accomInfo.selectedRooms; let j = index">
                <p style="font-weight: 600;">{{ "hotel.room" | translate}} {{j + 1}}: {{room.name}}</p>
                <div class="total-price base-price"
                  *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) !== 'E'">
                  <p>{{ "hotel.base-rate" | translate }}: </p>
                  <p>{{ room.rates[0].price.totalPrice.total | price }}€</p>
                </div>
                <div class="total-price base-price"
                  *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) !== 'E'">
                  <p *ngIf="room.rates[0].price.fees && room.rates[0].price.fees.amount > 0" style="color: #f46f69"
                    matTooltip="{{ 'hotel.due-at-property-details' |translate }}">{{
                    "hotel.due-at-property" | translate }} <i class="fa fa-question-circle"></i>: </p>
                  <p>{{room.rates[0].price.fees.amount | price }}€</p>
                </div>
                <div class="total-price base-price"
                  *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) === 'E'">
                  <p *ngIf="room.rates[0].price.baseRate && room.rates[0].price.baseRate.amount > 0">{{
                    "hotel.base-rate" | translate }}: </p>
                  <p>{{ room.rates[0].price.baseRate.amount | price }}€</p>
                </div>
                <div class="total-price base-price"
                  *ngIf="room.rates[0].price.taxAndServiceFee && room.rates[0].price.taxAndServiceFee.amount > 0">
                  <p matTooltip="{{ 'hotel.taxes-and-fees-details' |translate }}">{{ "hotel.taxes-and-fees" |
                    translate }} <i class="fa fa-question-circle"></i>: </p>
                  <p>{{ room.rates[0].price.taxAndServiceFee.amount | price }}€</p>
                </div>
                <div class="total-price base-price"
                  *ngIf="room.rates[0].price.salesTax && room.rates[0].price.salesTax.amount > 0">
                  <p>{{
                    "hotel.sales-tax" | translate }}: </p>
                  <p>{{ room.rates[0].price.salesTax.amount | price }}€</p>
                </div>
                <div class="total-price base-price"
                  *ngIf="room.rates[0].price.fees && room.rates[0].price.fees.amount > 0">
                  <p style="color: #f46f69" matTooltip="{{ 'hotel.due-at-property-details' |translate }}">{{
                    "hotel.due-at-property" | translate }} <i class="fa fa-question-circle"></i>: </p>
                  <p>{{ room.rates[0].price.fees.amount | price }}€</p>
                </div>
                <div class="total-price base-price" *ngIf="room.rates[0].price && room.rates[0].price.totalPrice.total">
                  <p>{{ "search.search-booked.total-price-by-room" | translate }}: </p>
                  <p>{{ room.rates[0].price.totalPrice.total | price }}€</p>
                </div>
              </div>
              <div class="total-price total-price-label">
                <p>{{ "search.search-booked.total-price" | translate }}: </p>
                <p>{{ getTotalPriceAccom() | price }}€</p>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="total-price total-price-label" *ngIf="accomInfo">
          <p>{{ "hotel.total-price-package" | translate }}: </p>
          <p>{{ getTotalPackage() | price }} €</p>
        </div>
      </div>
    </div>
    <div id="search-button-container" *ngIf="formSearchFlight" style="padding-left: 2rem;">
      <div class="row">
        <div class="buttons-cont col-12">
          <button class="custom-btn" id="search-button" (click)="searchFlights()" [ngClass]="{
              disabled:
                !formSearchFlight.valid ||
                (!oneWay &&
                  (!formSearchFlight.controls['dateOut'].value))
            }" [disabled]="
              !formSearchFlight.valid ||
              (!oneWay &&
                (!formSearchFlight.controls['dateOut'].value) || !allTravelersSelected())
            ">
            {{ "flights.form.search" | translate }}
          </button>
          <mat-slide-toggle (change)="changePackageRate()" [checked]="isPackageRate" [disabled]="isPackageRate == 'accommodation'">
            {{ 'hotel.package-rate' | translate}}
            <i class="fa fa-question-circle color-info" matTooltip="{{'hotel.package-rate-info' | translate}}"></i>
          </mat-slide-toggle>
          <div *ngIf="searchHasFailed" class="search-has-failed-container">
            <p>
              {{ "common.search-fail-custom-service.title" | translate }}
            </p>
            <button
              class="button-secondary custom-btn"
              (click)="
                userFilters.requestCustomFlight
                  ? goToCreateCustomFlight()
                  : utilsService.openChat()
              ">
              {{
                (userFilters.requestCustomFlight
                  ? "common.search-fail-custom-service.button"
                  : "common.open-chat"
                ) | translate
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div style="opacity: 1; z-index: 98">
    <app-loader-plane *ngIf="loadingFlights && modal"></app-loader-plane>
  </div>
</section>